import {
  call,
  CallEffect,
  put,
  PutEffect,
  takeLatest,
} from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { getArrayApiErrors } from 'utils/get-array-api-errors';
import { adminPermissionsActions } from 'features/admin-permissions/redux/admin-permissions.actions';
import { PayloadAction } from '@reduxjs/toolkit';
import { PermissionsResponse } from 'features/admin-permissions/api/types';
import { getPermissionsList } from 'features/admin-permissions/api';
import { toast } from 'react-toastify';
import { extractErrorMessage } from 'utils/extract-error-message.util';

function* getAdminPermissionsByPartnerName({
  payload,
}: PayloadAction<{ partnerName?: string }>): Generator<
  CallEffect<AxiosResponse<PermissionsResponse>> | PutEffect,
  void,
  AxiosResponse<PermissionsResponse>
> {
  try {
    const response = yield call(getPermissionsList, payload);
    yield put(adminPermissionsActions.getPermissionsSuccess(response.data));
  } catch (error) {
    toast.error(extractErrorMessage(error));
    yield put(
      adminPermissionsActions.getPermissionsFailure(getArrayApiErrors(error))
    );
  }
}

function* adminPartnersSaga() {
  yield takeLatest(
    adminPermissionsActions.getPermissionsRequest,
    getAdminPermissionsByPartnerName
  );
}

export default adminPartnersSaga;
